export default __webpack_public_path__ + "static/media/tag.017a3400.svg";